<template>
  <header class="mi-header">
    <div class="mi-header-inner">
      <div class="mi-logo">
        <router-link to="/" class="mi-wordmark">MLS Ingest</router-link>
        <a :href="parentUrl" class="mi-parent-line" rel="noopener">
          a <span class="mi-parent-mark">Brokurz</span> company
        </a>
      </div>

      <nav class="mi-nav" aria-label="Primary">
        <router-link to="/mls-directory">Directory</router-link>
        <router-link to="/status">Status</router-link>
        <router-link to="/contact">Sales</router-link>
      </nav>
    </div>
  </header>
</template>

<script>
import { PARENT_URL } from '../lib/brand'

export default {
  name: 'MarketingHeader',
  data() {
    return {
      parentUrl: PARENT_URL,
    }
  },
}
</script>
